// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_ListbycompromissoidResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos_servicos/listByCompromissoID
 *
 * Returns a list of services (servicos) for a given compromisso (appointment).
 * Each item includes the compromisso_servico record with joined orcamento_servico
 * and computed servico_label for display.
 *
 * @see Compromissos_servicos_model::dadosCompromissoServicoPorCompromissoID()
 */
import type { CompromissosServicos_ListbycompromissoidRow } from './CompromissosServicos_ListbycompromissoidRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CompromissosServicos_ListbycompromissoidResponseDados = CompromissosServicos_ListbycompromissoidRow[];

export type CompromissosServicos_ListbycompromissoidResponse = ApiResponse<CompromissosServicos_ListbycompromissoidResponseDados>;

registerResponseContract('CompromissosServicos_ListbycompromissoidResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      compromisso_servico_id:            { type: 'number',  required: false },
      compromisso_id:                    { type: 'number',  required: false },
      orcamento_servico_id:              { type: 'number',  required: false },
      compromisso_servico_status:        { type: 'number',  required: false },
      compromisso_servico_qtd:           { type: 'number',  required: false },
      compromisso_servico_valor:         { type: 'number',  required: false },
      compromisso_servico_data_cadastro: { type: 'string',  required: false },
      orcamento_servico_tipo:            { type: 'number',  required: false },
      servico_label:                     { type: 'string',  required: false },
    },
  },
})
